module.exports = __webpack_public_path__ + "img/nosc.a02a4af8.png";